module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sidekick/pro-user-flag.png"